import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/app/environments/environments';
import { Router, Routes } from '@angular/router';
import { Observer } from 'rxjs';
import { PageNotFoundComponent } from '../components/page-not-found/page-not-found.component';
import { DocumentsComponent } from '../modules/documentos/components/documents/documents.component';
import * as CryptoJS from 'crypto-js';
import { AppData } from 'src/app/models/interfaces.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  unsubscribe() {
    throw new Error('Method not implemented.');
  }
  private apiUrl = environment.apiUrl; // Reemplaza con la URL de la API ( dev ó prod)
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  // Método para actualizar el estado de autenticación
  setAuthenticationStatus(isAuthenticated: boolean) {
    this.isAuthenticatedSubject.next(isAuthenticated);
  }

  private menuData: any;
  UserApps: AppData[] = [];
  routes: Routes = [];

  private isLogoutCalled = false;

  constructor(
    private http: HttpClient,
    private jwtHelper: JwtHelperService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
    // Realiza tareas de limpieza aquí, como cancelar suscripciones a observables
  }

  getUserApps() {
    return this.UserApps;
  }

  login(credentials: any): Observable<{ success: boolean, errorMessage?: string }> {


    return new Observable((observer: Observer<{ success: boolean, errorMessage?: string }>) => {

      this.http.post(`${this.apiUrl}/GetTokenUserMenuAndCompanyApp`, credentials).subscribe(

        (response: any) => {
          if (!response.errorMessage) {
            this.setToken(response.token);
            localStorage.setItem('OpcionesMenu', JSON.stringify(response));
            localStorage.setItem('CompanyApp', JSON.stringify(response.CompanyApp));

            let defaultAppKey = null;
            for (const key in response.UserMenu) {
              if (response.UserMenu.hasOwnProperty(key) && response.UserMenu[key].IS_DEFAULT === 1) {
                localStorage.setItem('IdCompany', JSON.stringify(response.UserMenu[key].IdCompany));
                localStorage.setItem('appId', JSON.stringify(response.UserMenu[key].IdApp));
                localStorage.setItem('IdUser', JSON.stringify(response.UserMenu[key].IdUser));
                defaultAppKey = key;
                break;
              }
            }
            if (defaultAppKey !== null) {
              localStorage.setItem('Menu', JSON.stringify(response.UserMenu[defaultAppKey]));
            }

            this.UserApps = Object.values<any>(response.UserMenu).map((item: { IdApp: any; AppName: any; Dashboard: any }) => ({
              value: item.IdApp,
              label: item.AppName,
              dashboard: item.Dashboard,
            }));
            localStorage.setItem('UserApps', JSON.stringify(this.UserApps));


            const routes: any[] = [];

            for (const key in response.UserMenu) {
              if (response.UserMenu.hasOwnProperty(key)) {
                const app = response.UserMenu[key];
                const routeConfig = app.detail.map((detail: any) => {
                  const childrenRoutes: any[] = [];

                  if (detail.Menu.submenu) {
                    detail.Menu.submenu.forEach((submenu: any) => {
                      if (submenu.link != '') {
                        childrenRoutes.push({
                          //path: '/' + submenu.ROUTES_CONFIG_PATH + submenu.Menu.link,
                          path: CryptoJS.AES.encrypt(submenu.link, environment.CryptoKey).toString(),
                          component: DocumentsComponent
                        });
                      }
                    });
                  }

                  // Solo retornar si menu.Menu.link tiene un valor y childrenRoutes no es null
                  if (detail.Menu) {
                    return {
                      //path: menu.Menu.link,
                      path: CryptoJS.AES.encrypt(detail.Menu.link, environment.CryptoKey).toString(), //menu.Menu.link,
                      children: childrenRoutes
                    };
                  } else {
                    return null; // Retorna null si no se cumplen las condiciones
                  }
                }).filter((route: null) => route !== null); // Filtra las rutas nulas

                routes.push(...routeConfig);
              }
            }


            localStorage.setItem('dynamicRoutes', JSON.stringify(routes));

            observer.next({ success: true });
            observer.complete();
          }
          else {
            observer.next({ success: false, errorMessage: response.errorMessage });
            observer.complete();
          }
        },
        (error: any) => {
          if (error.error) {
            observer.next({ success: false, errorMessage: error.error.msg });
          } else {
            console.log("error: ", error);
            observer.next({ success: false, errorMessage: 'Error en la autenticación' });
          }
          observer.complete();
        }
      );
    });
  }

  getMenuData() {
    return localStorage.getItem('Menu');//this.menuData;
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
    this.isAuthenticatedSubject.next(true);
  }



  isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      return true;
    } else {
      return false;
    }
  }

  logout() {
    if (!this.isLogoutCalled) {
      this.isLogoutCalled = true;
      if (!localStorage.getItem('token')) {
        this.router.navigateByUrl('/login');
      } else {
        localStorage.clear();
        this.isAuthenticatedSubject.next(false);
        location.href = '/login';
      }
    }
  }

  // Método para obtener el token de acceso
  async getToken(): Promise<string | null> {
    const token = localStorage.getItem('token');
    if (token) {
      if (!this.isAuthenticated())
        return 'false';
      // En caso de ser necesario se realizar alguna verificación adicional del token
      return token;
    } else {
      // Si no hay token, lanzamos una excepción o la manejamos de otra manera según el flujo de la aplicación
      //this.logout();
      return null;
    }
  }



  // Método para refrescar el token
  refreshToken(): Promise<string | null> {
    // Aquí debes implementar la lógica para hacer la solicitud de refresco del token al servidor
    // Supongamos que usamos una llamada HTTP para obtener el nuevo token
    return this.http.post<any>('URL_PARA_REFRESCAR_TOKEN', {}).toPromise()
      .then(response => {
        const newToken = response.token; // Suponiendo que el servidor devuelve el nuevo token en la respuesta
        localStorage.setItem('token', newToken); // Actualiza el token en el almacenamiento local
        return newToken;
      })
      .catch(error => {
        console.error('Error al refrescar el token:', error);
        return null;
      });
  }

  // Método para obtener el tiempo de expiración del token
  private getTokenExpirationTime(token: string): number {
    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    return tokenPayload.exp;
  }


  // Método para obtener los nuevos elementos del MENU
  getNewMenu(obj: { is_login: number; id_user: string | null; id_company: string; id_app: string; }): Promise<string | null> {
    console.log("obj: ", obj);
    return this.http.post<any>(`${this.apiUrl}/GetTokenUserMenuAndCompanyApp`, obj).toPromise()
      .then(response => {
        return response.UserMenu;
      })
      .catch(error => {
        console.error('Error al refrescar el token:', error);
        return null;
      });
  }


}
